import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {translate} from 'views/module';

import KanbanColumn from './column/KanbanColumn';

import backend from 'utils/backend';

const CaseList = (props) => {
  const {
    statusProgressWrap: progressWrap,
  } = props;
  const [cases, setCases] = React.useState([]);

  React.useEffect(() => {
    let isActive = true;

    const loadCases = async () => {
      await progressWrap(async () => {
        const statusFilter = {key: 'status', value: ['OPEN', 'PENDING', 'COMPLETE']};
        const sort = {sortKey: 'updatedAt', sortDirection: 'DESC'};

        const caseResponse = await backend.case.queryCase([statusFilter], sort);

        if (isActive) {
          setCases(caseResponse?.list || []);
        }
      });
    };

    loadCases();

    return () => {
      isActive = false;
    };
  }, [progressWrap]);

  const caseStatuses = [
    {status: 'OPEN', title: translate('case.Status.OPEN.ColumnTitle')},
    {status: 'PENDING', title: translate('case.Status.PENDING.ColumnTitle')},
    {status: 'COMPLETE', title: translate('case.Status.COMPLETE.ColumnTitle')},
  ];
  const getCaseUpdatedAt = (caseData) => {
    const updatedAtTime = new Date(caseData.updatedAt).getTime();

    return Number.isNaN(updatedAtTime) ? 0 : updatedAtTime;
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: {
          md: 'calc(99vh - 32px)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          width: '100%',
          p: 3,
          overflowX: 'auto',
        }}
      >
        {
          caseStatuses.map((caseStatus) => {
            const statusCases = cases
                .filter((caseData) => caseData.status === caseStatus.status)
                .sort((firstCase, secondCase) => getCaseUpdatedAt(secondCase) - getCaseUpdatedAt(firstCase));

            return (
              <KanbanColumn
                key={caseStatus.status}
                title={caseStatus.title}
                cases={statusCases}
              />
            );
          })
        }
      </Box>
    </Box>
  );
};

CaseList.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(CaseList));
